import { axiosInstanceV2 } from "@src/shared/api";
import { USER_API_URL } from "../constants";
import { IUserInfoMeResponseDto } from "../interfaces/userInfoMeResponseDto";
import { useAuthStore } from "@src/entities/login/model/store/authStore";

export const getUserInfoMe = () => {
  const access_token = useAuthStore.getState().user?.tokens.access_token;
  return axiosInstanceV2.get<IUserInfoMeResponseDto>(
    USER_API_URL.getUserInfoMe(),
    {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    }
  );
};
